import type { PropsWithChildren } from "react";

import { useSelector } from "common/utilities/react-redux";
import { getIsAuthenticated } from "domains/authentication/selectors";
import { BookmarksPage } from "domains/bookmarks/components/BookmarksPage";
import { CreateOrEditCollection } from "domains/collection/components/edit/CreateOrEditCollection";
import { Forbidden } from "domains/routing/components/Forbidden";
import { TopicDetailPage } from "domains/topicDetail/components/TopicDetailPage";
import {
  getCanAccessCreate,
  getCanAccessMonitor,
  getCanDisplayBookmarks,
  getCanEditCollections,
} from "entities/permissions/selectors";

export const ProtectedPage = ({ children }: PropsWithChildren) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  return isAuthenticated ? children : <Forbidden />;
};

export const ProtectedBookmarksPage = () => {
  const canDisplayBookmarks = useSelector(getCanDisplayBookmarks);
  return canDisplayBookmarks ? <BookmarksPage /> : <Forbidden />;
};

export const ProtectedCreateOrEditCollectionPage = () => {
  const canEditCollections = useSelector(getCanEditCollections);
  return canEditCollections ? <CreateOrEditCollection /> : <Forbidden />;
};

export const ProtectedMonitorPage = ({ children }: PropsWithChildren) => {
  const canAccessMonitor = useSelector(getCanAccessMonitor);
  return canAccessMonitor ? children : <Forbidden onDismissRoute="/monitor" />;
};

export const ProtectedTopicDetailPage = () => {
  const canAccessCreate = useSelector(getCanAccessCreate);
  return canAccessCreate ? <TopicDetailPage /> : <Forbidden />;
};
